// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:29
import { LogEntryDefinition_abstract } from './../../abstract/SagaBase/Objects/LogEntryDefinition_abstract';
export class LogEntryDefinition extends LogEntryDefinition_abstract {}
